<body>
  <div class="container">
    <header class="header">
      <img
        src="../../../assets/images/VEMO_IMPULSO.svg"
        alt="Logo Vemo Impulso"
      />
    </header>

    <main>
      <ng-container *ngIf="hidePageConfirmationPlatform; else confirmDocuments">
        <section class="details">
          <h2>¡Listo!</h2>
          <div>En menos de 24 horas te enviaremos una propuesta</div>
          <span class="highlighted">para estrenar auto.</span>
        </section>
      </ng-container>
      <ng-template #confirmDocuments>
        <section class="confirm-documents">
          <mat-icon class="icon-check">check_circle</mat-icon>
          <h2>¡Documentos enviados!</h2>
          <div>En menos de 24 horas te</div>
          <span class="highlighted">daremos una respuesta.</span>
        </section>
      </ng-template>

      <section class="more">
        <img
          src="../../../assets/images/D1_BLANK.png"
          alt="Auto Vemo Impulso"
        />
        <a mat-raised-button href="https://vemovilidad.com/" class="link"
          >CONOCE MÁS DE VEMO IMPULSO</a
        >
      </section>
    </main>
  </div>
</body>
